module.exports = __webpack_public_path__ + "img/multi-s17.3f0cfb01.gif";